import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiMutationHook } from '../../../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../../../common/queryClient/getMutationFn';

import { AlgorithmUrl } from '../../query/AlgorithmUrl';
import {
  AlgorithmTargetFormDataType,
  AlgorithmTargetValidFormDataType,
} from '../schema/types';
import { AlgorithmTargetSchema } from '../schema/AlgorithmTargetSchema';

const postAlgorithmTarget = (
  algorithmTarget: AlgorithmTargetValidFormDataType,
  headers?: HttpHeaders
) =>
  apiClient
    .post<AlgorithmTargetFormDataType>(
      expand(AlgorithmUrl.TARGET, {}),
      AlgorithmTargetSchema.parseMutationDto(algorithmTarget),
      headers ? { headers } : undefined
    )
    .then((response) => response.data);

const putAlgorithmTarget = (
  id: number,
  algorithmTarget: Partial<AlgorithmTargetValidFormDataType>,
  headers?: HttpHeaders
) =>
  apiClient
    .put<AlgorithmTargetFormDataType>(
      expand(AlgorithmUrl.TARGET, { targetId: id }),
      AlgorithmTargetSchema.parseMutationDto(algorithmTarget),
      headers ? { headers } : undefined
    )
    .then((response) => response.data);

const deleteAlgorithmTarget = (targetId: number) =>
  apiClient
    .delete<void>(expand(AlgorithmUrl.TARGET, { targetId }))
    .then((response) => response.data);

export const useMutateAlgorithmTargetQuery = createApiMutationHook(
  ['algorithmTargets'],
  getMutationFn(postAlgorithmTarget, putAlgorithmTarget, deleteAlgorithmTarget)
);
